import { render, staticRenderFns } from "./FunnelChartItem.vue?vue&type=template&id=4a4fe0a5"
import script from "./FunnelChartItem.vue?vue&type=script&lang=js"
export * from "./FunnelChartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports